import axios from "axios";

import { routes } from "../../constants";
import { tableTokenConfig } from "./tableTokenConfig";

const clearSeat = async (code, position, token = null) => {
  const response = await axios.delete(
    routes.tableSeat(code, position),
    tableTokenConfig(token)
  );
  return response;
};
export default clearSeat;
